import { useWizard } from "storev2/wizardStore";

// Money model
function onChangeQuantity(_, record) {
  const { store } = useWizard.getState();
  if (record.quantity && record.bill) {
    const amount = record.quantity * record.bill;
    record.amount = amount;
  }
  store.money.set(record.id, record);
}

function layout() {
  const ctxView = {
    selectable: false,
    model: "sale_pos.money_count",
    domain: [],
    fields: {
      bill: { type: "numeric", readOnly: true },
      quantity: {
        type: "integer",
        withChange: onChangeQuantity,
        editable: true,
      },
      amount: { type: "numeric", readOnly: true },
    },
    list: [
      { name: "bill", width: "30%" },
      { name: "quantity", width: "20%", editable: true },
      { name: "amount", width: "30%" },
    ],
    form: [],
  };

  return ctxView;
}

export { layout };
